import Image from 'components/Common/Image'
import { useIntl } from 'react-intl'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'

const BannerContainer = styled.div`
  width: 100%;
  padding-top: ${rem(50)};

  ${mediaQueryUp.desktop} {
    padding-top: 0;
    height: ${rem(144)};
  }
`

const Banner = styled(Sheet)`
  width: 100%;
  height: 100%;
`

const ButtonsContainer = styled(Group)`
  flex: 1;
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${rem(-70)};
  width: 100%;
  /* Compensates image's slight deviation to the right (the letter)*/
  transform: translateX(${rem(-5)});


  ${mediaQueryUp.desktop} {
    margin-top: 0;
    width: auto;
  }
`

interface Props {
  onWriteMessage?: () => void
  hasMessages: boolean
  partnerOneName: string
  partnerTwoName: string
}

function WeddingWriteAMessageBanner({ onWriteMessage, hasMessages, partnerOneName, partnerTwoName }: Props) {
  const intl = useIntl()

  return (
    <BannerContainer>
      <Banner background="light-background" padding="0 20 28 20" desktopPadding="0 28" borderRadius="L">
        <Group direction="vertical" desktopDirection="horizontal" gap={20} verticalAlign="center" fullHeight>
          <ImageContainer>
            <Image
              id="le-letter_z4hfgh"
              alt={intl.formatMessage({ defaultMessage: 'Write a message', id: 'oQQudz-6734DDfxr945H', description: 'Alt text for the letter image in the wedding message banner.' })}
              width={200}
            />
          </ImageContainer>
          <Group direction="vertical" gap={8} verticalAlign="center" desktopVerticalAlign="start">
            <Heading variant="heading3alt" colour="normal-contrast" align="center" desktopAlign="start">
              {hasMessages ?
                  intl.formatMessage({ defaultMessage: 'Got a few words for us?', id: 'bC5zGenhrnmpeuXGXFnM', description: 'Heading inviting guests to write a public wedding message.' }) :
                  intl.formatMessage({ defaultMessage: 'Be the first to leave a note', id: 'S8cLYwTqjLSz-agEEmoy', description: 'Heading inviting the first guest to write a public wedding message.' })}
            </Heading>
            <BodyText variant="large" colour="normal-contrast" align="center" desktopAlign="start">
              {hasMessages ?
                  intl.formatMessage({ defaultMessage: 'Leave us a little love note. Your words will mean the world to us.', id: 'sx-nCbVVuxvqFnm_t7t1', description: 'Body copy inviting guests to write a public wedding message.' }) :
                  intl.formatMessage({
                    defaultMessage: 'Share your love, well wishes or favourite memory with {partnerOneName} & {partnerTwoName}.',
                    id: 'nhMDGiciMfiYYNyJFeJD',
                    description: 'Body copy inviting the first guest to write the first public wedding message.',
                  }, {
                    partnerOneName,
                    partnerTwoName,
                  })}
            </BodyText>
          </Group>
          <ButtonsContainer direction="vertical" desktopDirection="horizontal" gap={20} verticalAlign="center" horizontalAlign="stretch" desktopHorizontalAlign="end">
            <TextButton kind="primary" size="large" onClick={onWriteMessage}>
              {intl.formatMessage({ defaultMessage: 'Write a message', id: 'OMMGxdxWIC7uIP4L2cTc', description: 'Button label for opening the public wedding message modal.' })}
            </TextButton>
          </ButtonsContainer>
        </Group>
      </Banner>
    </BannerContainer>
  )
}

export default WeddingWriteAMessageBanner
